import React, { useEffect, useState, useRef } from 'react'
import { useSelector } from "react-redux";
import BudgetAllocationList from '../../../components/Multi/BudgetAllocation/BudgetAllocationList';
import { useNavigate } from 'react-router-dom';
import SubHeader from '../../../components/Subheader/Subheader';
import CustomBreadcrumbs from '../../../components/Tools/Breadcumbs';
import CreateButton from '../../../components/Tools/CreateButton';


const AllocateListPage = () => {
    const navigate = useNavigate();
    const { financialYears, authData } = useSelector((state) => state.authData);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [searchStr, setToSearchStr] = useState('');
    const [departmentId, setDepartmentId] = useState('');
    const [tier, setTier] = useState('');
    const fy_list = financialYears.payload.fy_list;
    const fyIdRef = useRef(localStorage.getItem('globalDateId'));

    const handleDateChange = (start, end, dateColumn, searchStr, fyId, tier, departmentId) => {
        setFromDate(start);
        setToDate(end);
        setToSearchStr(searchStr);
        setTier(tier);
        setDepartmentId(departmentId);
    };

    const handlePageTrigger = () => {
      fyIdRef.current = localStorage.getItem('globalDateId');
    }

    return (
        <div>
            <SubHeader fy_list={fy_list} handlePageTrigger={handlePageTrigger}/>
            <div className='scheme p-3'>
              <div className="row" style={{ padding: "10px 16px" }}>
                  <div className="col-md-6">
                      <h4 style={{ color: "#28326f", margin:0}}>Budget Allocations</h4>
                      <CustomBreadcrumbs linksArray={[]} title="Budget Allocations"/>
                  </div>
                  <div className="col-md-6">
                    <div className="d-flex gap-2" style={{ width: "auto", float: "right" }}>
                        <button type="button" className="navigation_button" onClick={() => navigate("/allocate-budget-approval")}>
                            <span className="fs-14px">Budget Limit Approval & Allotment</span>
                        </button>
                    </div>
                  </div>
              </div>
              <BudgetAllocationList fromDate={fromDate} toDate={toDate} searchStr={searchStr} approval={true} tier={tier} departmentId={departmentId} all={false}/>
              { authData.user.user_type === 'l1' && <CreateButton title={"Add Budget Allocation"} url={"/allocate-budget"} /> }
            </div>

            

        </div>
    )
}
export default AllocateListPage
